export const AT_LIST_VIEW_BOARD_SET =   'LIST_VIEW_BOARD_SET';
export const AT_LIST_VIEW_ACTION_SET =  'LIST_VIEW_ACTION_SET';
